// This polyfill is needed for the angular animations in old browsers, since the angular version only manage the last two major versions of the browsers
const isAnimationAvailable =
  typeof document.querySelector("body")?.animate === "function";

if (!isAnimationAvailable) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  import("web-animations-js");
}
